import React from 'react'
import { useHistory } from 'react-router-dom'
import { RegularButton } from '../components/RegularButton';
import styled from 'styled-components';

const NotFound = ({setAuth}) => {
  let history = useHistory();

  const handleReturn = (e) => {
    e.preventDefault();
    history.goBack();
  }
  return (
    <Wrapper>
      <h1>Hoppsan!</h1>
      <p>Du verkar försöka nå en sida som ej finns, tryck på knappen nedan för att återgå till sidan du kom ifrån.</p>
      <RegularButton primary="true" round="true" onClick={(e) => handleReturn(e)}>Tillbaka</RegularButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-content: center;
  align-items: center;
  justify-content: center;
  align-self: center;
  position: relative;
  z-index: 0;
  height: 100vh;
`

export default NotFound
